export const TotalApplications = [
    { job: "Software Engineer", applied: "6 Candidate", phoneScreen:"Allowed",interview:"Interview", hired:"4 Candidate",rejected:"2 Candidate"  },
    { job: "Software Engineer", applied: "6 Candidate", phoneScreen:"Allowed",interview:"Interview", hired:"4 Candidate",rejected:"2 Candidate"  },
    { job: "Software Engineer", applied: "6 Candidate", phoneScreen:"Allowed",interview:"Interview", hired:"4 Candidate",rejected:"2 Candidate"  },
    { job: "Software Engineer", applied: "6 Candidate", phoneScreen:"Allowed",interview:"Interview", hired:"4 Candidate",rejected:"2 Candidate"  },
  ];

  export const jobsData = [
    {id:1,designation:"UI/UX Developer",endDate:"No End Date", candidateName:"Candidate name",experience:"Traine"},
    {id:2,designation:"Backend Developer",endDate:"No End Date", candidateName:"Candidate name",experience:"5 Years"},
  ]

  export const RecruitCardData = [
    {
      id: 1,
      title: "Total Openings",
      value: "8",
      showIcon: true,
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-briefcase-business-icon lucide-briefcase-business"><path d="M12 12h.01"/><path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><path d="M22 13a18.15 18.15 0 0 1-20 0"/><rect width="20" height="14" x="2" y="6" rx="2"/></svg>
    },
    {
      id: 2,
      title: "Total Applications",
      value: "12",
      showIcon: true,
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-user-icon lucide-file-user"><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M15 18a3 3 0 1 0-6 0"/><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/><circle cx="12" cy="13" r="2"/></svg>
    },
    {
      id: 3,
      title: "Total Hired",
      value: "6",
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-check2-icon lucide-file-check-2"><path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m3 15 2 2 4-4"/></svg>
    },
    {
      id: 4,
      title: "Total Rejected",
      value: "4",
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-x-icon lucide-file-x"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m14.5 12.5-5 5"/><path d="m9.5 12.5 5 5"/></svg>
    },
    {
      id: 5,
      title: "New Applications",
      value: "6",
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-search2-icon lucide-file-search-2"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><circle cx="11.5" cy="14.5" r="2.5"/><path d="M13.3 16.3 15 18"/></svg>
    },
    {
      id: 6,
      title: "Shortlisted Candidates",
      value: "0",
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-round-check-icon lucide-user-round-check"><path d="M2 21a8 8 0 0 1 13.292-6"/><circle cx="10" cy="8" r="5"/><path d="m16 19 2 2 4-4"/></svg>
    },
    {
      id: 7,
      title: "Today's Interviews",
      value: "0",
      image:<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 24 24" fill="none" stroke="#33447e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-user-round-icon lucide-square-user-round"><path d="M18 21a6 6 0 0 0-12 0"/><circle cx="12" cy="11" r="4"/><rect width="18" height="18" x="3" y="3" rx="2"/></svg>
    },
  ];

  export const customDropDownData = ["Completed", "To Do", "On Hold", "In Progress", "Pending"]